const skills = [
  {
    id: '1',
    title: 'HTML',
    subtitle: "HTML é uma linguagem de marcação utilizada na construção de páginas na Web.",
    image : "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/skills/html.png?raw=true",
    category: 'front',
    description: 'HTML (Linguagem de Marcação de HiperTexto) é o bloco de construção mais básico da web. Define o significado e a estrutura do conteúdo da web. ',
  },
  {
    id: '2',
    title: 'CSS',
    subtitle: "Cascading Style Sheets é um mecanismo para adicionar estilos a uma página web",
    image : "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/skills/css.png?raw=true",
    category: 'front',
    description: "CSS (Cascading Style Sheets ou Folhas de Estilo em Cascata) é uma linguagem de estilo usada para descrever a apresentação de um documento escrito em HTML ou em XML.",
  },
  {
    id: '3',
    title: 'JS',
    subtitle: "Cascading Style Sheets é um mecanismo para adicionar estilos a uma página web",
    image : "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/skills/js.png?raw=true",
    category: 'front',
    description: 'JavaScript® (às vezes abreviado para JS) é uma linguagem leve, interpretada e baseada em objetos com funções de primeira classe, mais conhecida como a linguagem de script para páginas Web, mas usada também em vários outros ambientes sem browser, tais como node.js, Apache CouchDB e Adobe Acrobat. ',
  },
  {
    id: '4',
    title: 'React',
    subtitle: "Cascading Style Sheets é um mecanismo para adicionar estilos a uma página web",
    image : "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/skills/react.png?raw=true",
    category: 'front',
    description: 'O React é uma biblioteca front-end JavaScript de código aberto com foco em criar interfaces de usuário em páginas web.',
  },
  {
    id: '5',
    title: 'Redux',
    subtitle: "Cascading Style Sheets é um mecanismo para adicionar estilos a uma página web",
    image : "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/skills/redux.png?raw=true",
    category: 'front',
    description: 'Redux é uma biblioteca JavaScript de código aberto para gerenciar o estado do aplicativo. É mais comumente usado com bibliotecas como React ou Angular para criar interfaces de usuário. ',
  },
  {
    id: '6',
    title: 'Context',
    subtitle: "Cascading Style Sheets é um mecanismo para adicionar estilos a uma página web",
    image : "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/skills/context.png?raw=true",
    category: 'front',
    description: 'O React context API é um gerenciador de estado global e é uma funcionalidade implementada a pouco tempo no ecossistema do React, podendo resolver 90% das soluções do Redux de forma extremamente simples.',
  },
  {
    id: '7',
    title: 'Styled C.',
    subtitle: "Cascading Style Sheets é um mecanismo para adicionar estilos a uma página web",
    image : "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/skills/styled.png?raw=true",
    category: 'front',
    description: 'O Styled Components é uma biblioteca (lib) do React e do React Native que nos permite criar componentes de estilo ao escrever códigos CSS dentro de um arquivo JavaScript.',
  },
  {
    id: '8',
    title: 'Jest',
    subtitle: "Cascading Style Sheets é um mecanismo para adicionar estilos a uma página web",
    image : "https://raw.githubusercontent.com/kelvynkhrystian/portifolio/6d10f3e63f0443af570bf510386634ff4c5a0438/src/imgs/skills/jest.svg",
    category: 'front',
    description: 'Jest é uma estrutura de teste de JavaScript construída sobre o Jasmine e mantida pela Meta. Ele foi projetado e construído por Christoph Nakazawa com foco na simplicidade e suporte para grandes aplicativos da web. ',
  },
  {
    id: '9',
    title: 'RTL',
    subtitle: "Cascading Style Sheets é um mecanismo para adicionar estilos a uma página web",
    image : "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/skills/rtl.png?raw=true",
    category: 'front',
    description: 'React Testing Library é um conjunto de utilitários que permitem testar componentes React sem depender dos detalhes de implementação. Essa abordagem facilita a refatoração e também te orienta para as melhores práticas de acessibilidade.',
  },
  {
    id: '10',
    title: 'Node',
    subtitle: "Cascading Style Sheets é um mecanismo para adicionar estilos a uma página web",
    image : "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/skills/node.png?raw=true",
    category: 'back',
    description: 'Node.js é um software de código aberto, multiplataforma, baseado no interpretador V8 do Google e que permite a execução de códigos JavaScript fora de um navegador web. A principal característica do Node.js é sua arquitetura assíncrona e orientada por eventos.',
  },
  {
    id: '11',
    title: 'MySql',
    subtitle: "Cascading Style Sheets é um mecanismo para adicionar estilos a uma página web",
    image : "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/skills/mysql.png?raw=true",
    category: 'back',
    description: 'O MySQL é um sistema de gerenciamento de banco de dados, que utiliza a linguagem SQL como interface. É atualmente um dos sistemas de gerenciamento de bancos de dados mais populares da Oracle Corporation, com mais de 10 milhões de instalações pelo mundo. ',
  },
  {
    id: '12',
    title: 'Express',
    subtitle: "Cascading Style Sheets é um mecanismo para adicionar estilos a uma página web",
    image : "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/skills/exp.png?raw=true",
    category: 'back',
    description: 'Express.js é um framework para Node.js que fornece recursos mínimos para construção de servidores web. Foi lançado como software livre e de código aberto sob a Licença MIT. É um dos mais populares frameworks para servidores em Node.js.',
  },
  {
    id: '13',
    title: 'Sequelize',
    subtitle: "Cascading Style Sheets é um mecanismo para adicionar estilos a uma página web",
    image : "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/skills/sequelize.png?raw=true",
    category: 'back',
    description: 'Sequelize é o nome do ORM que usaremos. O Sequelize abstrai os comandos de operações de SQL, e faz com que possamos usar linguagem de programação que já estamos usando no backend para nos conectarmos e operarmos o banco.',
  },
  {
    id: '14',
    title: 'JWT',
    subtitle: "Cascading Style Sheets é um mecanismo para adicionar estilos a uma página web",
    image : "https://raw.githubusercontent.com/kelvynkhrystian/portifolio/8adbb4d1c4c9bb82c85f3bed6454bb3ebf583eb1/src/imgs/skills/jwt.svg",
    category: 'back',
    description: 'O JSON Web Token é um padrão da Internet para a criação de dados com assinatura opcional e/ou criptografia cujo payload contém o JSON que afirma algum número de declarações. Os tokens são assinados usando um segredo privado ou uma chave pública/privada. ',
  },
  {
    id: '15',
    title: 'Chai',
    subtitle: "Cascading Style Sheets é um mecanismo para adicionar estilos a uma página web",
    image : "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/skills/chai.png?raw=true",
    category: 'back',
    description: 'Chai é uma biblioteca de afirmação BDD/TDD para Node e para o navegador, que pode ser equiparada com qualquer framework de testes de JavaScript. ',
  },
  {
    id: '16',
    title: 'Mocha',
    subtitle: "Cascading Style Sheets é um mecanismo para adicionar estilos a uma página web",
    image : "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/skills/mocha.png?raw=true",
    category: 'back',
    description: 'O Mocha é um framework de testes unitários simples e bastante prático. Você poderá testar ele no lado do servidor com o Node ou no lado do cliente, em seu navegador.',
  },
  {
    id: '17',
    title: 'Sinon',
    subtitle: "Cascading Style Sheets é um mecanismo para adicionar estilos a uma página web",
    image : "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/skills/sinon.png?raw=true",
    category: 'back',
    description: 'O Sinon é um pacote open-source que fornece diversas funcionalidades (como mocks, spies e stubs) que facilitam os nossos testes no JavaScript. O Sinon por sí só não é um framework de testes, ele deve ser utilizado em conjunto com outra ferramenta para execução de testes, como por exemplo o Mocha ou Ava.',
  },
  {
    id: '18',
    title: 'Linux',
    subtitle: "SO",
    image : "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/skills/linux.png?raw=true",
    category: 'ferr',
    description: 'Linux é um termo popularmente empregado para se referir a sistemas operativos ou sistemas operacionais que utilizam o Kernel Linux. ',
  },
  {
    id: '19',
    title: 'Git',
    subtitle: "SO",
    image : "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/skills/git.png?raw=true",
    category: 'ferr',
    description: 'Git ₍ₒᵤ em inglês britânico₎ é um sistema de controle de versões distribuído, usado principalmente no desenvolvimento de software, mas pode ser usado para registrar o histórico de edições de qualquer tipo de arquivo. ',
  },
  {
    id: '20',
    title: 'Docker',
    subtitle: "SO",
    image : "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/skills/docker.png?raw=true",
    category: 'ferr',
    description: 'Docker é um conjunto de produtos de plataforma como serviço que usam virtualização de nível de sistema operacional para entregar software em pacotes chamados contêineres. Os contêineres são isolados uns dos outros e agrupam seus próprios softwares, bibliotecas e arquivos de configuração.',
  },
  {
    id: '21',
    title: 'Vercel',
    subtitle: "SO",
    image : "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/skills/vercel.jpg?raw=true",
    category: 'ferr',
    description: 'Vercel Inc., anteriormente Zeit, é uma plataforma de nuvem americana como empresa de serviços. A empresa mantém a estrutura de desenvolvimento web Next.js. A arquitetura da Vercel é construída em torno do Jamstack e as implantações são feitas por meio de repositórios Git. A',
  },
  {
    id: '22',
    title: 'Trello',
    subtitle: "SO",
    image : "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/skills/trello.png?raw=true",
    category: 'ferr',
    description: 'Trello é um aplicativo de gerenciamento de projeto baseado na web originalmente desenvolvido em 2011 pela então Fog Creek Software. Em 2017, foi adquirido pela empresa australiana Atlassian. Ele opera um modelo de negócio freemium.',
  },
  {
    id: '23',
    title: 'Slack',
    subtitle: "SO",
    image : "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/skills/slack.png?raw=true",
    category: 'ferr',
    description: 'Slack é um programa de mensagens instantâneas desenvolvido pela Slack Technologies e de propriedade da Salesforce. Embora o Slack tenha sido desenvolvido para comunicações profissionais e organizacionais, ele também foi adotado como uma plataforma comunitária.',
  },
  {
    id: '24',
    title: 'Figma',
    subtitle: "SO",
    image : "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/skills/figma.png?raw=true",
    category: 'ferr',
    description: 'Figma é um editor gráfico de vetor e prototipagem de projetos de design baseado principalmente no navegador web, com ferramentas offline adicionais para aplicações desktop para GNU/Linux, macOS e Windows.',
  },
  {
    id: '25',
    title: 'Thunder',
    subtitle: "SO",
    image : "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/skills/thunder.png?raw=true",
    category: 'ferr',
    description: 'Thunder Client – Requisições HTTP a partir do Visual Studio Code. No mundo do desenvolvimento Web, o Postman é a ferramenta mais escolhida para realizar testes em APIs. No entanto, depender de uma ferramenta externa pode muitas vezes dificultar o desenvolvimento e testagem.',
  }
  
]

export default skills;